"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Message = void 0;
class Message {
    constructor(data) {
        if (data === null || data === void 0 ? void 0 : data.raw) {
            this.raw = data.raw;
        }
        if (data === null || data === void 0 ? void 0 : data.metaData) {
            this.metaData = data.metaData;
        }
    }
    addMetaData(meta) {
        if (this.metaData) {
            this.metaData.push(meta);
        }
        else {
            this.metaData = [meta];
        }
    }
    getLastMetaData() {
        if (this.metaData !== undefined && this.metaData.length > 0) {
            return this.metaData[this.metaData.length - 1];
        }
        else {
            return null;
        }
    }
    isValid() {
        if (this.type === null || this.type === '') {
            return false;
        }
        if (!this.raw || this.raw === null || this.raw === '') {
            return false;
        }
        return true;
    }
}
exports.Message = Message;
//# sourceMappingURL=message.js.map